import { Button, ChevronDownIcon, ChevronUpIcon } from 'components'

interface Props {
  onClick: () => void
  isExpanded: boolean
}

export default function ExpandEventBannerButton({ onClick, isExpanded }: Props) {
  return (
    <Button
      rightIcon={isExpanded ? <ChevronUpIcon fontSize="md" /> : <ChevronDownIcon fontSize="md" />}
      onClick={onClick}
    >
      {isExpanded ? 'Less' : 'More'} Details
    </Button>
  )
}
